let timestamp = new Date().getTime();

let firstLoad = true;

$('.reviews:not(.reviews--pages) #reviewsList').slick({
    variableWidth: false,
    slidesToShow: 1,
    dots: false,
    arrows: false,
    speed: 300,
    centerMode: false,
    initialSlide: 0,
    infinite: false,
    adaptiveHeight: true
});

if ($('.reviews--pages').length) {
    const itemsPerPage = $('.reviews__pages').data('items-per-page');
    const pathName = 'https://qs-goldenhippo.s3.us-west-2.amazonaws.com/assets/drc/v02/dataJson/';
    const externalPath = $('#reviewsExternal').data('external-json');

    if ($('#reviewsExternal').length) {
        $.ajax({
            dataType: "json",
            url: pathName + externalPath,
            success: (data) => {
                window.reviewsArr = window.reviewsArrExtended;
                const avgRating = getAvgRating(data);
    
                // update total rating
                $('.reviews__rating-text').text(avgRating).removeClass('hide');
                $('.reviews__rating-load').addClass('hide');
                $('.reviews .fa-rating').addClass('s-' + Math.ceil(avgRating)).attr('title', avgRating + ' out of 5');
                $('.reviews__base').html($('.reviews__base').text().replace('$reviewsAmount', '<b>' + data.length + '</b>')).removeClass('hide');
    
                $.getScript('https://pagination.js.org/dist/2.5.0/pagination.min.js', function() {
                    var container = $('#pagination');
                    container.pagination({
                        dataSource: data,
                        pageSize: itemsPerPage,
                        pageRange: 1,
                        showPageNumbers: true,
                        showPrevious: true,
                        showNext: true,
                        showNavigator: true,
                        showFirstOnEllipsisShow: true,
                        showLastOnEllipsisShow: true,
                        prevText: `<svg class="icon icon--chevron-prev"><use xlink:href="svg/sprite.svg?rel=${timestamp}#CHEVRON_DOWN"/></svg>`,
                        nextText: `<svg class="icon icon--chevron-next"><use xlink:href="svg/sprite.svg?rel=${timestamp}#CHEVRON_DOWN"/></svg>`,
                        callback: function(response, pagination) {
                            loadReviewsPage(1, response);
                        }}
                    )
                });
            },
            error: (request, status, error) => {
                console.log(request);
                console.log(status);
                console.log(error);
            }
        })
    } else {
        const avgRating = getAvgRating(window.reviewsArr);
        //update total rating
        $('.reviews__rating-text').text(avgRating);
        $('.reviews .fa-rating').addClass('s-' + Math.ceil(avgRating)).attr('title', avgRating + ' out of 5');
        $('.reviews__base').html($('.reviews__base').text().replace('$reviewsAmount', '<b>' + window.reviewsArr.length + '</b>'));

        $.getScript('https://pagination.js.org/dist/2.5.0/pagination.min.js', function() {
            var container = $('#pagination');

            container.pagination({
                dataSource: window.reviewsArr,
                pageSize: itemsPerPage,
                pageRange: 1,
                showPageNumbers: true,
                showPrevious: true,
                showNext: true,
                showNavigator: true,
                showFirstOnEllipsisShow: true,
                showLastOnEllipsisShow: true,
                prevText: `<svg class="icon icon--chevron-prev"><use xlink:href="svg/sprite.svg?rel=${timestamp}#CHEVRON_DOWN"/></svg>`,
                nextText: `<svg class="icon icon--chevron-next"><use xlink:href="svg/sprite.svg?rel=${timestamp}#CHEVRON_DOWN"/></svg>`,
                callback: function(response, pagination) {
                    loadReviewsPage(1, response);
                }
            })
        });
    }
}

function getAvgRating(reviews) {
    let total = 0;
    reviews.forEach((item) => {
        total += parseFloat(item.rating);
    });
    let res = (total / reviews.length).toFixed(2);
    if (res.toString().split('.')[1] == '00') {
        return res.toString().split('.')[0]
    } 

    return res
}

function loadReviewsPage(pageBtn, reviewsData) {
    const itemsPerPage = $('.reviews__pages').data('items-per-page');
    let page;
    if (typeof pageBtn == 'number') {
        page = pageBtn;
    } else {
        page = $(pageBtn).data('page');
    }
    const startingIndex = (page - 1) * itemsPerPage;
    const pageData = reviewsData.slice(startingIndex, startingIndex + itemsPerPage);

    $('.reviews__item-wrap').each(function(){
        $(this).fadeOut(250, function () {
            $(this).remove();
        });
    });

    $('.reviews__page').promise().done(function () {
        $(() => {
            pageData.forEach((item, idx) => {
                const element = `
                    <div class="reviews__item-wrap" style="display:none;">
                        <div class="reviews__item">
                            <div class="reviews__top">
                                <p class="rating"><span class="fa-rating s-${item.rating}" title="${item.rating} out of 5">${item.ratingValue} out of 5</span></p>
                                <span class="reviews__date">${item.date}</span>
                            </div>
                            ${item.title != '' ? `<p class="reviews__item-title">${item.title}</p>` : ''}
                            <p class="reviews__comment">${item.comment}</p>
                            <p class="reviews__info">
                                ${item.author}
                                ${reviewsConfig.showVerifiedBuyerLabel == true ? 
                                `<span class="reviews__verified">
                                    <svg class="icon">
                                        <use xlink:href="svg/sprite.svg?rel=${timestamp}#VERIFIED"/>
                                    </svg>
                                    Verified Buyer
                                </span>`
                                : ''}
                            </p>
                        </div>
                    </div>
                `;
    
                $(element).appendTo('.reviews__page').fadeIn(250)
            });
        });
    });

    if (!firstLoad) {
        $('html, body').animate({
            scrollTop: $('.reviews').offset().top
        }, 500);
    }

    if (firstLoad) {
        firstLoad = false;
    }
}